import { WebSocketService } from "../FileManager/websocketService.js";
import { UrlResolveService } from "../FileManager/urlResolveService.js";
import { useDocumentStore } from "../store/documentStore.js";

let store = {}

export function start() {
    store = useDocumentStore();
    
    const handlers = [
      { event: EVENT_TYPES.UPDATED, handler: handleItemUpdate },
      { event: EVENT_TYPES.LOCKED, handler: handleItemUpdate },
      { event: EVENT_TYPES.UNLOCKED, handler: handleItemUpdate },
      { event: EVENT_TYPES.CREATED, handler: handleItemChange },
      { event: EVENT_TYPES.MOVED, handler: handleItemChange },
      { event: EVENT_TYPES.DELETED, handler: handleItemDelete },
    ];

    handlers.forEach(({ event, handler }) => {
      WebSocketService.addEventListener(event, handler);
    });

    WebSocketService.connect();
}

const getCurrentLocation = () => {
return window.location.pathname.replace(/^\/|\/$/g, "").toUpperCase();
};

const getItemDirectory = (path) => {
return path.substring(0, path.lastIndexOf("/")).toUpperCase();
};

const isCurrentLocation = (path) => {
return path.toUpperCase() === getCurrentLocation() ||
    UrlResolveService.decode(path.toUpperCase()) === UrlResolveService.decode(getCurrentLocation());
};

const handleItemUpdate = async (event) => {
const itemDir = getItemDirectory(event.ItemPath);
if (isCurrentLocation(itemDir)) {
    const fullPath = `${new URL(UrlResolveService.getRootUrl()).origin}/${event.ItemPath
    }`;
    await store.updateItem(fullPath);
}
};

const handleItemChange = async (event) => {
const itemDir = getItemDirectory(event.ItemPath);
const targetDir = event.TargetPath
    ? getItemDirectory(event.TargetPath)
    : null;

if (
    isCurrentLocation(itemDir) ||
    (targetDir && isCurrentLocation(targetDir))
) {
    await store.refreshFolder(true);
}
};

const handleItemDelete = async (event) => {
const currentLocation = getCurrentLocation();
const itemDir = getItemDirectory(event.ItemPath);
if (
    isCurrentLocation(itemDir) ||
    currentLocation.startsWith(event.ItemPath.toUpperCase()) ||
    UrlResolveService.decode(currentLocation).startsWith(UrlResolveService.decode(event.ItemPath.toUpperCase()))) {
    await store.refreshFolder(true);
}
};

export const EVENT_TYPES = {
  UPDATED: "upload",
  LOCKED: "locked",
  UNLOCKED: "unlocked",
  CREATED: "created",
  MOVED: "moved",
  DELETED: "deleted",
};
